import { graphql } from 'gql';

export const importActKC2TemplateAsExcelGql = graphql(`
    mutation uerImportActKC2TemplateAsExcel($actKC2Template: FileInput!, $workOrderId: Long!) {
        uerImportActKC2TemplateAsExcel(actKC2Template: $actKC2Template, workOrderId: $workOrderId) {
            data {
                actKC2Id
                constructionTypeId
                workOrderObjectId
            }
            hasValidation
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
